<script>
import { addCommas } from '@/lib/misc';
import secondsToDuration from '@/lib/secondsToDuration';

export default {
  name: 'ReportGeneric',
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    firstData() {
      return (this.report.data || [])[0] || {};
    },
  },
  methods: {
    addCommas,
    secondsToDuration,
  },
};
</script>
<style lang="less">
.report-vertical-aligned {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
